import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    name: 'Home',
    path: '/home',
    meta: {
      title: '首页',
    },
    component: () => import('../views/Home.vue'),
  },
  {
    name: 'Company',
    path: '/company',
    redirect: '/company/introduce',
    component: () => import('../views/Company'),
    children: [
      {
        name: 'Introduce',
        path: 'introduce',
        component: () => import('../views/Company/Introduce.vue'),
        meta: {
          title: '公司介绍',
        },
      },
      {
        name: 'Dynamic',
        path: 'dynamic',
        component: () => import('../views/Company/Dynamic.vue'),
        meta: {
          title: '公司动态',
        },
      },
      {
        name: 'Architecture',
        path: 'architecture',
        component: () => import('../views/Company/Architecture.vue'),
        meta: {
          title: '组织架构',
        },
      },
      {
        name: 'Activity',
        path: 'activity',
        component: () => import('../views/Company/Activity.vue'),
        meta: {
          title: '党团活动',
        },
      },
      {
        name: 'Responsibility',
        path: 'responsibility',
        component: () => import('../views/Company/Responsibility.vue'),
        meta: {
          title: '社会责任',
        },
      },
      {
        name: 'popularizeLaw',
        path: 'popularizeLaw',
        component: () => import('../views/Company/popularizeLaw.vue'),
        meta: {
          title: '普法宣传',
        },
      },
      {
        name: 'police',
        path: 'police',
        component: () => import('../views/Company/police.vue'),
        meta: {
          title: '生态警务',
        },
      }
    ],
  },
  {
    name: 'CompanyCulture',
    path: '/companyCulture',
    component: () => import('../views/CompanyCulture.vue'),
    meta: {
      title: '企业文化',
    },
  },
  {
    name: 'ProductDisplay',
    path: '/productDisplay/:type?',
    component: () => import('../views/ProductDisplay.vue'),
    meta: {
      title: '产品展示',
    },
  },
  {
    name: 'Classify',
    path: '/classify/:index?',
    component: () => import('../views/Classify.vue'),
    meta: {
      title: '商品列表',
    },
  },
  {
    name: 'BusinessField',
    path: '/businessField',
    component: () => import('../views/BusinessField.vue'),
    meta: {
      title: '业务领域',
    },
  },
  {
    name: 'Investment',
    path: '/investment',
    component: () => import('../views/Investment.vue'),
    meta: {
      title: '招商加盟',
    },
  },
  {
    name: 'JoinUs',
    path: '/joinUs',
    component: () => import('../views/JoinUs.vue'),
    meta: {
      title: '加入我们',
    },
  },
  {
    name: 'ContactUs',
    path: '/contactUs',
    component: () => import('../views/ContactUs.vue'),
    meta: {
      title: '联系我们',
    },
  },
  {
    name: 'News',
    path: '/news',
    component: () => import('../views/News.vue'),
    meta: {
      title: '新闻',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  document.title = `Kmt Style`
  next()
})

export default router
